import React, { FC } from 'react';

import i18n from '@yandex-int/i18n';
import { getMonitoringLabels } from 'client/api/appStoreApi';
import { ErrorBoundary } from 'client/blocks/ErrorBoundary/ErrorBoundary';
import { AliceAppMonitoringDashboard } from 'client/blocks-redesign/AliceAppMonitoringDashboard/AliceAppMonitoringDashboard';
import { AliceAppTitle } from 'client/blocks-redesign/AliceAppTitle/AliceAppTitle';
import { PageLoader } from 'client/blocks-redesign/Loader/PageLoader';
import { useLoadingData } from 'client/hooks/useLoadingData';
import { AliceApp } from 'client/model/skill';
import { isInstallableApp } from 'client/utils';
import * as keyset from 'i18n/Monitoring';

import styles from './AliceAppMonitoring.module.scss';

const t = i18n(keyset);

interface Props {
    skill: AliceApp;
}

const MonitoringPageContent: React.FC<Props> = ({ skill }) => {
    const { loadingMeta } = useLoadingData({
        loader: async () => getMonitoringLabels(),
    });
    const { data: solomonLabels, state } = loadingMeta;

    if (state === 'loading') {
        return <PageLoader />;
    }

    if (state === 'error' || isInstallableApp(skill)) {
        return <div>{t('error')}</div>;
    }

    return <AliceAppMonitoringDashboard skill={skill} solomonLabels={solomonLabels!} />;
};

export const AliceAppMonitoringPage: FC<Props> = ({ skill }) => {
    return (
        <ErrorBoundary withHomepageLink>
            <AliceAppTitle aliceApp={skill} />
            <div className={styles.monitoringPage__container}>
                <h1 className={styles.monitoringPage__header}>{t('header')}</h1>
                {skill.onAir ? <MonitoringPageContent skill={skill} /> : <div>{t('error-no-public')}</div>}
            </div>
        </ErrorBoundary>
    );
};
